const isNull = (value: unknown) => value == null

export default isNull
